export default {
    WEBSITE_LABEL: 'Websajt',
    CANCEL: 'Poništi',
    CHANGE: 'Izmeni',
    LOGOUT: 'Odjavi se',
};
